<section class="text-start flex flex-col items-start">
	<div class="w-full h-[343px] overflow-hidden">
		<img
			src="https://isonewswire.com/wp-content/uploads/2020/08/placeholder-shapes-green.png"
			alt="Educational Graphic for SignIT Integration"
			class="w-full h-full object-cover"
		/>
	</div>

	<div class="py-6">
		<p class="text-lg font-medium text-gray-950">
			End-to-End Digital Signing, Right From Closer
		</p>

		<p class="text-base text-gray-700 pb-4 pt-1">
			We pre-tag the signature fields, send the documents, and keep you updated
			every step of the way.
		</p>

		<p class="text-base font-medium text-gray-700">
			Connect to SignIT to get started.
		</p>

		<p class="text-gray-700 text-base pt-1">
			<span class="font-medium text-gray-700">Your first 3 sends are free</span>
			— then just {{ integrationCost }} per signed package.
		</p>
	</div>
</section>
